export default "__VITE_ASSET__TdlG8tWW__"